import { Module } from "@/constants";
import { useParams } from "react-router-dom";

import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import RouteGuard from "@/components/RouteGuard";
import { LayoutSwitcher } from "@/components/layout";

export default function DictionaryRoutes() {
  const { dict, id } = useParams();

  const config = getDictionaryConfig(dict as Module);
  const Creator = config.Creator;
  const Editor = config.Editor;
  const DictionaryList = config.List;

  return (
    <RouteGuard>
      <LayoutSwitcher>
        {dict && id === "new" && <Creator dict={dict as Module} id={id} />}
        {dict && id && id !== "new" && <Editor dict={dict as Module} id={id} />}
        {dict && !id && <DictionaryList />}
      </LayoutSwitcher>
    </RouteGuard>
  );
}
